import { CircularProgress } from '@gto/ui/circular-progress'

export const Loader = () => {
  return (
    <div className="flex items-center justify-center py-8">
      <CircularProgress
        aria-label="Loading..."
        title="Loading..."
      />
    </div>
  )
}
